export default __webpack_public_path__ + "static/media/integrity-temp-grip-biegfestigkeit.d7ed974c.svg";